import { useEffect, useState } from "react";
import { TextAreaInput } from "swing-components";
import { translate } from "utils/string-table";

import {
  ModalSubFeedbackBody,
  ModalSubFeedbackFooter,
  ModalSubFeedbackHeader,
  NeutralData,
  NeutralStep,
} from "~components/ModalSubFeedback";

/********* Types ********/
type ModalSubFeedbackContentNeutralCommentsProps = {
  onDismiss: () => void;
  onSubmit: (data: NeutralData) => void;
  neutralData: NeutralData;
  setNeutralData: (data: NeutralData) => void;
  setNeutralStep: (step: NeutralStep) => void;
  subName?: string;
  hasSubmissionError?: boolean;
};

/********* Component ********/
export function ModalSubFeedbackContentNeutralComments(
  props: ModalSubFeedbackContentNeutralCommentsProps,
) {
  const {
    neutralData,
    onDismiss,
    setNeutralData,
    setNeutralStep,
    subName,
    onSubmit: submitSubFeedbackForm,
    hasSubmissionError,
  } = props;

  /********* Hooks ********/
  const [_updatedComment, _setUpdatedComment] = useState(neutralData.comment ?? "");

  useEffect(() => {
    if (hasSubmissionError === false) setNeutralStep("summary");
  }, [hasSubmissionError, setNeutralStep]);

  /********* Handlers ********/
  function handleOnCommentChange(comment: string) {
    _setUpdatedComment(comment);
  }

  function handleOnSubmit() {
    const updatedData = {
      ...neutralData,
      ...(!!_updatedComment.trim() && { comment: _updatedComment }),
    };

    setNeutralData(updatedData);
    submitSubFeedbackForm(updatedData);
  }

  return (
    <>
      <ModalSubFeedbackHeader title={translate("GIVE_FEEDBACK_LABEL")} onDismiss={onDismiss} />
      <ModalSubFeedbackBody hasApiError={hasSubmissionError}>
        <div css={{ padding: "8px 0" }}>
          <TextAreaInput
            label={translate("MSF_NEUTRAL_FEEDBACK_COMMENT_LABEL", subName)}
            subLabel={translate("MSF_NEUTRAL_FEEDBACK_COMMENT_PUBLIC_SHARING_NOTE", subName)}
            value={_updatedComment}
            onChange={(comment: string) => handleOnCommentChange(comment)}
            placeholder={translate("MSF_COMMENT_TEXT_INPUT_PLACEHOLDER")}
          />
        </div>
      </ModalSubFeedbackBody>
      <ModalSubFeedbackFooter
        buttonPrimary={{
          onClick: handleOnSubmit,
          isDisabled: false,
          text: translate("LABEL_SUBMIT"),
        }}
        buttonSecondary={{
          onClick: () => {
            // Save the current comment before navigating back
            // Do not check if it's empty, if they cleared the
            // comment before navigating back, we would like to
            // keep that empty state.
            setNeutralData({ ...neutralData, comment: _updatedComment });
            setNeutralStep("reasons");
          },
          isDisabled: false,
          text: translate("LABEL_BACK"),
        }}
      />
    </>
  );
}
